import { feedApi } from "../api";
import {
  createFeedFreshnessTelemetryBatcher,
  type FeedFreshnessResult,
} from "./feedFreshness";

const telemetry = createFeedFreshnessTelemetryBatcher({
  send: (batch) => feedApi.recordFreshnessTelemetry(batch),
  flushIntervalMs: 60_000,
  maxBatchSize: 100,
});

export function recordFeedFreshnessTelemetry(
  result: FeedFreshnessResult,
): void {
  telemetry.record(result);
}

export function resetFeedFreshnessTelemetry(): void {
  telemetry.reset();
}
